import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeStore {
    theme: 'dark' | 'light';
    setTheme: (theme: 'dark' | 'light') => void;
}

export const useTheme = create<ThemeStore>()(
    persist(
        (set) => ({
            theme: 'light',
            setTheme: (theme) => {
                set({ theme });
                if (theme === 'dark') {
                    document.documentElement.classList.add('dark');
                } else {
                    document.documentElement.classList.remove('dark');
                }
            },
        }),
        {
            name: 'theme-storage',
        }
    )
);

export const initializeTheme = () => {
    const theme = useTheme.getState().theme;
    if (theme === 'dark') {
        document.documentElement.classList.add('dark');
    }
};
